import React, { useState, useEffect, useContext } from "react";
import createAuth0Client from "@auth0/auth0-spa-js";
import Auth0Client from "@auth0/auth0-spa-js/dist/typings/Auth0Client";

const DEFAULT_REDIRECT_CALLBACK = (state) =>
    window.history.replaceState({}, document.title, window.location.pathname);

export const Auth0Context = React.createContext(null);
export const useAuth0 = () => useContext(Auth0Context);

interface IProps {
    children: any;
    onRedirectCallback: any;
    initOptions: Auth0ClientOptions
}

export let accessToken = '';

export const Auth0Provider = (props: IProps) => {
    const { initOptions, children } = props;
    let redirCallBack = props.onRedirectCallback;

    if (!redirCallBack)
        redirCallBack = DEFAULT_REDIRECT_CALLBACK;

    const [isAuthenticated, setIsAuthenticated] = useState<boolean>();
    const [userRole, setUserRole] = useState<string>(undefined);
    const [user, setUser] = useState();
    const [auth0Client, setAuth0] = useState<Auth0Client>();
    const [loading, setLoading] = useState(true);
    const [popupOpen, setPopupOpen] = useState(false);

    useEffect(() => {
        const initAuth0 = async () => {
            const auth0FromHook = await createAuth0Client(initOptions);
            // console.info("initAuth0 auth0FromHook", auth0FromHook)
            setAuth0(auth0FromHook);

            if (window.location.search.includes("code=") &&
                window.location.search.includes("state=")) {
                const { appState } = await auth0FromHook.handleRedirectCallback();
                redirCallBack(appState);
            }

            const isAuthenticated = await auth0FromHook.isAuthenticated();

            setIsAuthenticated(isAuthenticated);

            if (isAuthenticated)
                accessToken = (await auth0FromHook.getIdTokenClaims()).__raw;
            else
                accessToken = ''

            if (isAuthenticated) {
                const user = await auth0FromHook.getUser();
                // console.info("initAuth0 user", user)
                setUser(user);
            }
            verifyRole();
            setLoading(false);
        };
        initAuth0();
        // eslint-disable-next-line
    }, []);

    const loginWithPopup = async (params = {}) => {
        setPopupOpen(true);
        try {
            await auth0Client.loginWithPopup(params);
        } catch (error) {
            console.error(error);
        } finally {
            setPopupOpen(false);
        }
        const user = await auth0Client.getUser();
        setUser(user);
        setIsAuthenticated(true);

        try {
            accessToken = (await auth0Client.getIdTokenClaims()).__raw;
        }
        catch {
            accessToken  = ''
            setIsAuthenticated(false);
        }

        // console.info("--------------> loginWithPopup user", user)
        verifyRole();

        return user;
    };

    // const loginWithPopup = async (params = {}) => {
    const verifyRole = () => {
        let role = undefined;
        if (user) {
            const roles = user["https://areaferrerro.logico.srl/roles"] as any;
            if (roles && roles.length > 0 && roles.includes("admin")) {
                role = "admin";
            }
        }
        setUserRole(role)
        return role;
    }

    const handleRedirectCallback = async () => {
        setLoading(true);
        await auth0Client.handleRedirectCallback();
        const user = await auth0Client.getUser();
        // console.info("handleRedirectCallback user", user)
        setLoading(false);
        setIsAuthenticated(true);
        setUser(user);
    };

    return (
        <Auth0Context.Provider
            value={{
                isAuthenticated,
                user,
                loading,
                popupOpen,
                userRole,
                loginWithPopup,
                verifyRole,
                handleRedirectCallback,
                getIdTokenClaims: (...p) => auth0Client.getIdTokenClaims(...p),
                //loginWithRedirect: (...p) => auth0Client.loginWithRedirect(...p),
                getTokenSilently: (...p) => auth0Client.getTokenSilently(...p),
                getTokenWithPopup: (...p) => auth0Client.getTokenWithPopup(...p),
                logout: (...p) => auth0Client.logout(...p),
            }}
        >
            {children}
        </Auth0Context.Provider>
    );
};